import React from "react";
import { Pressable, Text, TextInput, View } from "react-native";
import { headerPurple, primaryDark, secondaryDark } from "../../Constants/Colors";

const TextInputTopLabel = React.forwardRef(
  (
    {
      onPress,
      containerStyle,
      width,
      value,
      placeholder,
      type,
      onChangeText,
      multiline,
      autoFocus,
      style,
      notEditable,
      onSubmitEditing,
      onLayout,
      secureTextEntry,
      endComponent,
      onKeyPress,
      helperText,
    },
    ref
  ) => {
    const hasValue = value && value.length > 0;

    return (
      <Pressable
        onPress={onPress}
        style={[
          { alignItems: "flex-start", position: "relative" },
          containerStyle || { width: "100%" },
          width && { width: width },
        ]}
        onLayout={onLayout}
      >
        {/* Floating Label */}
        {hasValue && (
          <Text
            style={{
              position: "absolute",
              left: 16,
              top: -10,
              zIndex: 10,
              color: secondaryDark,
              fontWeight: "700",
              fontSize: 13,
              backgroundColor: "#ffffff",
              paddingHorizontal: 8,
              borderRadius: 4,
              transition: "all 0.2s ease",
            }}
          >
            {placeholder.replace("Enter", "").replace("Select", "").trim()}
          </Text>
        )}

        {/* Input Container */}
        <View
          style={{
            width: "100%",
            backgroundColor: "#ffffff",
            borderRadius: 12,
            borderColor: hasValue ? secondaryDark : "#d1d5db",
            borderWidth: 2,
            marginLeft: 0,
            justifyContent: "center",
            overflow: "visible",
            minHeight: 56,
            boxShadow: hasValue ? `0 4px 16px ${secondaryDark}22` : "0 1px 3px rgba(0, 0, 0, 0.1)",
            transition: "all 0.2s ease",
          }}
        >
          <TextInput
            value={value}
            onChangeText={(k) => {
              if (type !== "number") return onChangeText(k);
              let e = k.replace(/,/g, "");
              if (Number(e) >= 0) return onChangeText(e);
            }}
            multiline={multiline}
            autoFocus={autoFocus}
            style={[
              {
                padding: 16,
                paddingTop: 18,
                width: "100%",
                fontSize: 16,
                color: "#1f2937",
                backgroundColor: "transparent",
                outline: "none",
              },
              style,
            ]}
            keyboardType={type === "number" ? "decimal-pad" : "default"}
            placeholder={placeholder}
            placeholderTextColor="#9ca3af"
            ref={ref}
            editable={!notEditable}
            onSubmitEditing={onSubmitEditing}
            secureTextEntry={secureTextEntry}
            onKeyPress={onKeyPress}
          />

          {/* End Component */}
          {endComponent ? (
            <View style={{ position: "absolute", right: 16, top: 16 }}>{endComponent}</View>
          ) : null}
        </View>

        {/* Helper Text */}
        {helperText && typeof helperText === "string" && helperText.length > 0 && (
          <Text
            style={{
              color: "#6b7280",
              fontSize: 13,
              marginLeft: 4,
              marginTop: 6,
              opacity: 0.9,
            }}
          >
            {helperText}
          </Text>
        )}
      </Pressable>
    );
  }
);

export const TextInputSmall = React.forwardRef(
  (
    {
      onPress,
      containerStyle,
      width,
      value,
      placeholder,
      type,
      onChangeText,
      multiline,
      autoFocus,
      style,
      notEditable,
      onSubmitEditing,
      onLayout,
      secureTextEntry,
      endComponent,
      onKeyPress,
    },
    ref
  ) => {
    const hasValue = value && value.length > 0;

    return (
      <Pressable
        onPress={onPress}
        style={[
          { alignItems: "flex-start", position: "relative" },
          containerStyle || { width: "100%" },
          width && { width: width },
        ]}
        onLayout={onLayout}
      >
        {/* Floating Label */}
        {hasValue && (
          <Text
            style={{
              position: "absolute",
              left: 14,
              top: -9,
              zIndex: 10,
              color: secondaryDark,
              fontWeight: "700",
              fontSize: 12,
              backgroundColor: "#ffffff",
              paddingHorizontal: 6,
              borderRadius: 3,
              transition: "all 0.2s ease",
            }}
          >
            {placeholder.replace("Enter", "").replace("Select", "").trim()}
          </Text>
        )}

        {/* Input Container */}
        <View
          style={{
            width: "100%",
            backgroundColor: "#ffffff",
            borderRadius: 8,
            borderColor: hasValue ? secondaryDark : "#d1d5db",
            borderWidth: 1.5,
            marginLeft: 0,
            justifyContent: "center",
            overflow: "visible",
            minHeight: 44,
            boxShadow: hasValue ? `0 2px 10px ${secondaryDark}18` : "0 1px 2px rgba(0, 0, 0, 0.08)",
            transition: "all 0.2s ease",
          }}
        >
          <TextInput
            value={value}
            onChangeText={(k) => {
              if (type !== "number") return onChangeText(k);
              let e = k.replace(/,/g, "");
              if (Number(e) >= 0) return onChangeText(e);
            }}
            multiline={multiline}
            autoFocus={autoFocus}
            style={[
              {
                padding: 12,
                paddingTop: 13,
                width: "100%",
                fontSize: 14,
                color: "#1f2937",
                backgroundColor: "transparent",
                outline: "none",
              },
              style,
            ]}
            keyboardType={type === "number" ? "decimal-pad" : "default"}
            placeholder={placeholder}
            placeholderTextColor="#9ca3af"
            ref={ref}
            editable={!notEditable}
            onSubmitEditing={onSubmitEditing}
            secureTextEntry={secureTextEntry}
            onKeyPress={onKeyPress}
          />

          {/* End Component */}
          {endComponent ? (
            <View style={{ position: "absolute", right: 12, top: 12 }}>{endComponent}</View>
          ) : null}
        </View>
      </Pressable>
    );
  }
);

export default TextInputTopLabel;
